import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilGerente, usuarioPerfilRepresentante } from '../../../usuario/usuario-perfil';


/** Acessos permitidos a consulta das metas da Rafitec */
export const acessosRafitecMeta: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilGerente, usuarioPerfilRepresentante];

@Injectable()
export class CanActivateRafitecMeta implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosRafitecMeta);
    }
}
